/*# sourceMappingURL=request-lease-transfer-detail.component.css.map */
